import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

export const CoinsIcon: FunctionComponent<IIconProps> = ({ ...props }) => (
  <Icon {...{ viewBox: '0 0 16 16', ...props }}>
    <Path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.333}
      d="M12.06 6.913A4 4 0 1 1 6.893 12M4.667 4h.666v2.667m5.807 2.586.467.474-1.88 1.88m-.394-6.274a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
    />
  </Icon>
)
